import React, { Component, useState, useEffect } from 'react';
import ImageComponent from '../../CommonComponent/CommonImage';
import { withTranslation } from 'react-i18next';
import './future-dates.css';
// import LastPeriod from '../period-calculator-landing-page/LastPeriod';
// import SetReminderLastPeriod from './SetReminderLastPeriod';
import dateUtils from '../../../commonUtils/DateUtils';
import { isMobile } from 'react-device-detect';
import { postDataFetcher } from '../../../dataFetcher';
import CONFIG_OBJECT from '../../../config/config';
import App_Constants from '../../../app-constants/App_Constants';
// import SetRemindersPaginator from './SetRemindersPaginator';
// import PillsInjectionsData from './PillsInjectionsData';
import configData from '../../../temp/config';
import SetReminderLastPeriod from '../set-reminders/SetReminderLastPeriod';
import FutureDateLastPeriodData from './FutureDateLastPeriodData';

let selectedTrack = {
    key: '',
    id: ''
}

let selectedEvent = {
    key: '',
    id: ''
}

let currentMonthCycle = {
    dayValue: new Date().getDate(),
    monthValue: new Date().getMonth(),
    yearValue: new Date().getFullYear(),
    cycleLength: 28,
    periodDuration: 4,
    futureStartDate: '',
    fromFutureEndDate: ''
}

const FutureDates = (props) => {
    const [showTitle, setShowTitle] = useState(isMobile);
    const [showHeader, setShowHeader] = useState(true)
    const [showResultSection, setShowResultSection] = useState(isMobile ? false : true);
    const [showForm, setShowForm] = useState(true);
    const [track, setTrack] = useState('');
    const [eventsData, setEventsData] = useState({});
    const [disableBtn, setDisableBtn] = useState(true);
    const [showDefaultCalender, setShowDefaultCalender] = useState(isMobile ? false : true);
    const [resultData, setResultData] = useState({
        apiData: {},
        showCalender: false
    })
    const [showEditForm, setShowEditForm] = useState(false);

    useEffect(() => {
        currentMonthCycle = {
            dayValue: new Date().getDate(),
            monthValue: new Date().getMonth(),
            yearValue: new Date().getFullYear(),
            cycleLength: 28,
            periodDuration: 4,
            futureStartDate: '',
            fromFutureEndDate: ''
        }
    }, [])

    // This function gets called whenever we changed anything in child component(Drop-down)
    const sendLastPeriodData = (dayValue, monthValue, yearValue, cycleLength, periodDuration, enableBtn, futureStartDate, fromFutureEndDate) => {
        futureStartDate = `${dateUtils.formatDate(Number(futureStartDate.getMonth()) + 1)}-${dateUtils.formatDate(futureStartDate.getDate())}-${futureStartDate.getFullYear()}`
        fromFutureEndDate = `${dateUtils.formatDate(Number(fromFutureEndDate.getMonth()) + 1)}-${dateUtils.formatDate(fromFutureEndDate.getDate())}-${fromFutureEndDate.getFullYear()}`
        currentMonthCycle = {
            dayValue: dayValue,
            monthValue: monthValue,
            yearValue: yearValue,
            cycleLength: cycleLength,
            periodDuration: periodDuration,
            futureStartDate: futureStartDate,
            fromFutureEndDate: fromFutureEndDate
        }
        // console.log(currentMonthCycle)
        if (enableBtn) {
            setDisableBtn(false)
            document.getElementById("calculate-period-button-id").disabled = false;
        } else {
            setDisableBtn(true)
            document.getElementById("calculate-period-button-id").disabled = true;
        }
        document.getElementById("calculate-period-button-id").focus()
    }

    const mySubmitHandler = (e) => {
        e.preventDefault()
    }

    const calculatePeriod = () => {
        let month = Number(currentMonthCycle.monthValue) + 1;
        let data = {
            lastPeriodDate: `${dateUtils.formatDate(month)}-${dateUtils.formatDate(currentMonthCycle.dayValue)}-${currentMonthCycle.yearValue}`,
            periodDuration: Number(currentMonthCycle.periodDuration),
            cycleLength: `${currentMonthCycle.cycleLength}`,
            StartDate: currentMonthCycle.futureStartDate,
            EndDate: eventsData.key.value === 'one' ? currentMonthCycle.futureStartDate : currentMonthCycle.fromFutureEndDate

        };

        let restURL = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.FUTURE_DATES_REST_URL}`;
        if (isMobile) {
            setShowForm(false)
            setShowEditForm(true)
            setShowTitle(false);
            setShowHeader(false);
        }

            postDataFetcher(`${restURL}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem('language')}`, data)
                .then(res => {
                    // console.log(res)
                    if (res.data.HasError) {
                        setResultData({
                            hasError: true
                        })

                    } else {
                        setShowDefaultCalender(false);
                        setResultData({
                            showCalender: true,
                            apiData: res.data.Data,
                            showForm: false,
                        });
                        setShowResultSection(true)
                        if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
                    }
                }, err => {
                    setResultData({
                        hasError: true
                    })
                });
            if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;


        // setIsremidnerSet(false)
        if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
    }

    const setSelectedEventData = (item) => {
        currentMonthCycle = {
            dayValue: new Date().getDate(),
            monthValue: new Date().getMonth(),
            yearValue: new Date().getFullYear(),
            cycleLength: 28,
            periodDuration: 4,
        }
        selectedEvent.key = '';
        selectedEvent.id = `{${item.id}}`;

        if (item.fields.key.value !== '' && selectedEvent.key !== item.fields.key.value) {
            selectedEvent.key = item.fields.key.value;
            setTrack(item.fields.key.value);
            setEventsData(item.fields);
            setResultData({
                showCalender: false,
            });
            setShowDefaultCalender(true)
            // setIsremidnerSet(false)
            setShowForm(true)
            // if (isMobile) setShowTracks(false)
            if (isMobile) props.hideTitle();
        }


        if (isMobile) {
            setShowHeader(true);
            setShowResultSection(false);
            setShowTitle(true);
            setTimeout(function(){ window.scrollTo(0, 0); }, 0);
        }
        // To scroll  top of the page
        // if(isMobile)
        
    }

    const getFormattedDate = (date) => {
        let d = new Date(date);
        let formattedDate = `${d.getDate()} ${months[d.getMonth()]}, ${d.getFullYear()}`;
        return formattedDate;
    }

    const hideEditedForm = () => {
        setShowTitle(true)
        setShowHeader(true)
        setShowForm(true)
        setShowEditForm(false)
        setShowResultSection(false)
        setTimeout(function(){ window.scrollTo(0, 0); }, 0);
    }

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return (

        <>
            {/* {showTracks ? */}
            {showTitle && <div className="future-dates-goal-header">
                <h1 className="sub-heading"> {props.componentData.title.value}</h1>
            </div>}
            {showHeader && <div className="future-events-header">
                {/* <p>{props.componentData.title.value} </p> */}
                <div className="future-events">
                    {/*  */}
                    {props.componentData.futureEvents.map((item, index) => {
                        return (
                            <>
                                <div className={`${(item.fields.key.value === track) ? 'active' : ''}`} key={`${item.fields.key.value}${index}`} onClick={() => setSelectedEventData(item)}>
                                    <span className="future-events-features" >{item.fields.title.value}</span>
                                </div>
                            </>

                        )
                    })}
                </div>
            </div>}
            {showEditForm && <div className="future-dates-recalculate-wrap-period-form">
                <div className="fdlp-mobile">
                <img src={`${configData.sitecoreApiHost}${props.parentCompData.datePickerLogo.value.src}`} />
                    <span>{props.componentData.dateSelectionLabel.value}</span>
                    <span>{currentMonthCycle.dayValue} {months[currentMonthCycle.monthValue]}, {currentMonthCycle.yearValue}</span>
                </div>
                <div className="avg-period-mobile">
                    <span>{props.componentData.durationSelection1Label.value}</span>
                    <span>{currentMonthCycle.periodDuration} {props.t('PeriodCalculator_DaysLabel')}</span>
                </div>
                <div className="cycle-length-mobile">
                    <span>{props.componentData.durationSelection2Label.value}</span>
                    <span>{currentMonthCycle.cycleLength} {props.t('PeriodCalculator_DaysLabel')}</span>
                </div>
                <div className="cycle-length-mobile ltr-common">
                    <span>{props.componentData.title.value}</span>
                    <span>{getFormattedDate(currentMonthCycle.futureStartDate)}</span>
                </div>
                {eventsData.key && eventsData.key.value === 'multi' && <div class="future-date-to">
                    <span>{props.componentData.title.value}</span>
                    <span>{getFormattedDate(currentMonthCycle.fromFutureEndDate)}</span>
                </div>}
                <button onClick={hideEditedForm}>
                <img src={`${configData.sitecoreApiHost}${props.parentCompData.editLogo.value.src}`} />
                </button>
            </div>}
            {/* :
                <div className="view-all-reminder-parent">
                    <div className="choose-all-reminders" onClick={showAllReminders}>

                        {isMobile && <img className="back-arrow" src={`${configData.sitecoreApiHost}${props.parentCompData.leftArrowActiveLogo.value.src}`} alt="" />}
                        <span >choose another event</span>
                    </div>
                </div>} */}



            {eventsData.key && (eventsData.key.value === 'multi' || eventsData.key.value === 'one') &&
                <div className="form-container future-dates-form" onSubmit={mySubmitHandler}>
                    {showForm && <form role="form" className="form-inline">
                        <div className="toolform">
                            <FutureDateLastPeriodData sendLastPeriodData={sendLastPeriodData}
                                componentData={props.componentData}
                                parentCompData={props.parentCompData}
                                currentMonthCycle={currentMonthCycle}
                                selectedEvent={selectedEvent.key} />
                                <div className="submitBtnWrapper">
                                    <button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
                                    {props.componentData.submitLabel.value}
                                    <span></span>
                                    {/* <ImageComponent imageIcon={props.parentCompData.forwardRightArrowLogo.value.src} /> */}
                                    </button>

                                </div>
                           
                        </div>
                    </form>}

                    {showResultSection && <div className="future-dates-result-section">
                        {showDefaultCalender && <div className="blank-div">
                        </div>
                        }
                        {!showDefaultCalender && <div className="calendar">
                            {resultData.apiData && <div className="reminder-set">
                                <img src={`${configData.sitecoreApiHost}${resultData.apiData.imageUrl.src}`} alt="" className="future-dates-side-img" />
                                {/* <ImageComponent imageIcon={""} /> */}
                                <div className="reminder-success">
                                    <h5 className="reminder-success-msg" style={{'color' : resultData.apiData.isOnPeriod ? '#DA291C' : '#3C9941'}}>{resultData.apiData.resultMessage}</h5>

                                </div>
                                {(eventsData.key.value === 'multi' && resultData.apiData.periodDaysNote) ? <div className="future-period-days">
                                    <h5 className="future-period-days-msg">{resultData.apiData.periodDaysNote}</h5>
                                    <span>
                                        {resultData.apiData.periodStartDate} - {resultData.apiData.periodEndDate}
                                    </span>
                                </div> : null}
                            </div>}
                        </div>}

                    </div>}


                </div>}

        </>
    )
}


export default withTranslation()(FutureDates)

